import React from 'react'
import { Box, Typography } from '@mui/material'
import { Avatar, Tooltip } from '../../eid-ui'
import { useTranslation } from 'react-i18next'

const tooltipStyles = {
    boxShadow: '0 2px 16px 0 rgba(0, 0, 0, 0.11)',
    padding: '8px',
    maxWidth: '800px', // some arbitrary width
}

const PersonOption = ({
    option,
    labelProp = 'friendlyName',
    loginProp = 'login',
    imageUrlProp = 'imageThumbUrl',
    cdnUrl,
    disableImage = false,
    checkIfOptionIsDisabled,
    disableOptionTooltipLabelKey = 'NotAvailableForSelection',
}) => {
    const isDisabled = checkIfOptionIsDisabled?.(option)
    const { t } = useTranslation()

    return (
        <Box
            display="flex"
            alignItems="center"
            padding="8px"
            sx={{
                cursor: isDisabled ? 'not-allowed' : 'pointer',
                pointerEvents: 'auto',
            }}
            onClick={(e) => {
                if (isDisabled) {
                    e.preventDefault()
                    e.stopPropagation()
                    return
                }
            }}
        >
            {!disableImage && (
                <Box component="span" paddingRight="20px">
                    <Avatar
                        src={
                            option?.[imageUrlProp]
                                ? `${cdnUrl}${option[imageUrlProp]}`
                                : ''
                        }
                    />
                </Box>
            )}
            <Tooltip
                color="#5D6870"
                fontColor="#ffffff"
                enterDelay={500}
                enterNextDelay={500}
                tooltipStyles={tooltipStyles}
                title={
                    <>
                        <Typography
                            style={{
                                fontSize: '14px',
                                fontWeight: 600,
                            }}
                        >
                            {option[labelProp]}
                        </Typography>
                        <Typography
                            style={{
                                fontSize: '12px',
                            }}
                        >
                            {option[loginProp]}
                        </Typography>
                        {isDisabled && (
                            <Typography
                                style={{
                                    fontSize: '12px',
                                    color: '#ff9944',
                                    marginTop: '4px',
                                    fontWeight: 600,
                                }}
                            >
                                {t(disableOptionTooltipLabelKey)}
                            </Typography>
                        )}
                    </>
                }
            >
                <Box>
                    <Typography
                        display="block"
                        style={{
                            fontSize: '14px',
                            color: '#73767A',
                            fontWeight: 600,
                        }}
                        noWrap={true}
                    >
                        {option[labelProp]}
                    </Typography>
                    <Typography
                        display="block"
                        style={{
                            fontSize: '12px',
                            color: '#73767A',
                        }}
                        noWrap={true}
                    >
                        {option[loginProp]}
                    </Typography>
                </Box>
            </Tooltip>
        </Box>
    )
}
const LabelOnlyOption = ({ option, labelProp }) => (
    <Typography style={{ wordBreak: 'break-all' }}>
        {option[labelProp]}
    </Typography>
)

const LabelWithSubLabelOption = ({ option, labelProp, subLabelProp }) => (
    <div
        style={{
            display: 'flex',
            padding: '8px 10px',
        }}
    >
        <div>
            <span style={{ color: '#000' }}>{option[labelProp]}</span>
            <div>{option[subLabelProp]}</div>
        </div>
    </div>
)

const optionComponents = {
    label: LabelOnlyOption,
    labelWithSubLabel: LabelWithSubLabelOption,
    person: PersonOption,
}

export default optionComponents
